// Module dependencies
import { FC, ReactNode } from 'react';
import { ChakraProvider, defaultSystem } from '@chakra-ui/react';
import { ThemeProvider } from 'next-themes';

interface ProviderProps {
  children: ReactNode;
}

const Provider: FC<ProviderProps> = ({ children }) => {
  return (
    <ChakraProvider value={defaultSystem}>
      <ThemeProvider>
        {children}
      </ThemeProvider>
    </ChakraProvider>
  );
};

export { Provider };

